module.exports = __webpack_public_path__ + "img/meta.5431fc61.jpeg";